import { useEffect, useState } from 'react';
import { $window } from '@umu/umu-dom';
import { Millisecond } from '@umu/umu-types';

interface IProps {
    show: boolean;
    children: JSX.Element;
    delay?: Millisecond;
}

/**
 * 延时渲染
 * @author Kody
 */
export const DelayRender = (props: IProps) => {
    const { delay = 500, show, children } = props;
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        $window.setTimeout(() => {
            setFlag(show);
        }, delay);
    }, [show]);

    return show && flag ? children : null;
};
